import { DraftConfigurationColor, PrintColor } from '@/types';
import { hasOwnProperty } from '@/utils/hasOwnProperty';

const isPrintColor = (color: DraftConfigurationColor | PrintColor): color is PrintColor =>
  hasOwnProperty(color, 'restrictions');

export const preventUnprintableColorCombinations = (
  colors: DraftConfigurationColor[],
  defaultColor: DraftConfigurationColor | PrintColor
) => {
  if (isPrintColor(defaultColor)) {
    const availableColorIds = defaultColor.restrictions?.printableAbovePrintColors.map(
      ({ id }) => id
    );
    colors.forEach(({ id }, index) => {
      if (id && !availableColorIds.includes(id)) {
        colors[index] = defaultColor;
      }
    });
  }
};
